import React, { useState } from 'react';

import {
    Modal, Button, Group, Stack, Text, Loader, Title,
} from '@mantine/core';
import dayjs from 'dayjs';
import { useQuery } from 'react-query';

import { InputField } from '../blocks/edit_blocks';
import stringToHex from '../tools/string-to-hex';
import { getGenericQuery } from '../utils/neurons';
import '../css/change-history.css';

const DATE_CLIENT_FORMAT = 'HH:mm:ss (DD.MM.YY)';

export default function ChangeHistory({
    lastChange, project, type, id,
}) {
    const [isActive, setActive] = useState(false);

    const {
        data: changes, isFetching,
    } = useQuery([`v2/${project}/story/${type}/${id}/history/`], getGenericQuery, {
        enabled: !!id && isActive,
        retry: 0,
        refetchOnWindowFocus: false,
    });

    function toggleModal() {
        setActive(!isActive);
    }

    return (
        <div className="change-history">
            <InputField
                name="change-author"
                label="Автор изменения"
                value={lastChange?.author}
                readOnly
            />
            <Button className="change-history__button" onClick={toggleModal} />
            <Modal
                opened={isActive}
                onClose={toggleModal}
                title={(
                    <Group spacing={6}>
                        <Title order={4}>История изменений</Title>
                        {isFetching && <Loader size="xs" />}
                    </Group>
                )}
            >
                <Stack spacing={6}>
                    {changes?.results.map(({ author, created_at }, i) => (
                        <Group
                            position="apart"
                            key={`${author}-${created_at}`}
                        >
                            <Text color={stringToHex(author)}>
                                {author}
                            </Text>
                            <Text style={{ fontFamily: 'Courier New, monospace' }}>
                                {dayjs(created_at).format(DATE_CLIENT_FORMAT)}
                            </Text>
                        </Group>
                    ))}
                    {!isFetching && !changes?.results?.length && (
                        <Text>
                            Изменений пока нет
                        </Text>
                    )}
                </Stack>
            </Modal>
        </div>
    );
}
